// Complete mock data for Bravo Cinemastreaming with detailed content information

export const heroSlides = [
  {
    id: 1,
    opera: "Tristan und Isolde",
    composer: "Wagner",
    subtitle: "VERSIÓN DIGITAL DISPONIBLE",
    tagline: "CONTRATA VERSIÓN DIGITAL",
    image: "https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=1920&q=80",
    cta: "VER FICHA",
    contentId: "tristan-und-isolde"
  },
  {
    id: 2,
    opera: "La guineueta astuta",
    composer: "Janáček",
    subtitle: "EDICIÓN ESPECIAL DISPONIBLE",
    tagline: "CONTRATA VERSIÓN DIGITAL",
    image: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=1920&q=80",
    cta: "VER FICHA",
    contentId: "la-guineueta-astuta"
  },
  {
    id: 3,
    opera: "L'elisir d'amore",
    composer: "Donizetti",
    subtitle: "ESTRENO DIGITAL 14/12/2025",
    tagline: "CONTRATA VERSIÓN DIGITAL",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1920&q=80",
    cta: "VER FICHA",
    contentId: "elisir-amore"
  },
  {
    id: 4,
    opera: "Lady Macbeth de Mtsensk",
    composer: "Shostakovich",
    subtitle: "EDICIÓN ESPECIAL DISPONIBLE",
    tagline: "CONTRATA VERSIÓN DIGITAL",
    image: "https://images.unsplash.com/photo-1460723237483-7a6dc9d0b212?w=1920&q=80",
    cta: "VER FICHA",
    contentId: "lady-macbeth"
  }
];

export const features = [
  { id: 1, icon: "MessageCircle", label: "Live chat" },
  { id: 2, icon: "Music", label: "Score following" },
  { id: 3, icon: "Subtitles", label: "Subtitles" },
  { id: 4, icon: "Video", label: "Multi-camera" },
  { id: 5, icon: "User", label: "Conductor" }
];

// Complete content database with detailed information
export const contentDatabase = [
  {
    id: "lady-macbeth",
    title: "Lady Macbeth de Mtsensk",
    composer: "Dmitri Xostakòvitx",
    theater: "Gran Teatre del Liceu",
    season: "24-25",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1460723237483-7a6dc9d0b212?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1460723237483-7a6dc9d0b212?w=1920&q=80",
    status: "available",
    isFeatured: true,
    premiereDate: "2024-10-15",
    synopsis: "Una mujer sometida al sistema patriarcal tradicional y circaica en una estructura familiar inmovible y una sexualidad femenina reducida a los propósitos procreadores. Estamos hablando, pues, de una rebelión erótica como primer gesto en la búsqueda de un sueño, una libertad individual frente a la tiranía familiar.",
    synopsisExtended: "Pero esta pasión como se confunde con el amor, el enamoramiento con la rendición, la rendición con la sumisión y, finalmente, la sumisión con el sacrificio, y la aceptación del sufrimiento: Katerina está sola. Con una mirada herida y una identidad por construir se manifiesta con violencia, matar es lo único sólido.",
    tags: ["ÒPERA", "LADY MACBETH DE MTSENSK", "XOSTAKÒVITX", "TEMPORADA 24/25", "ALEX OLLÉ", "JOSEP PONS", "SARA JAKUBIAK", "PAVEL ČERNOCH"],
    productInfo: {
      theater_name: "Gran Teatre del Liceu",
      recording_year: "2024",
      duration: "3h 15min",
      subtitles_version: "Español, English, Français, Deutsch"
    },
    cast: [
      { performer: "ALEXEI BOTNARCIUC", character: "Boris Izmàilov" },
      { performer: "DANIEL KIRCH", character: "Zinovi Izmàilov" },
      { performer: "SARA JAKUBIAK", character: "Katerina Izmàilova" },
      { performer: "PAVEL ČERNOCH", character: "Serguei" },
      { performer: "ANNA GORBACHYOVA", character: "Aksinya" },
      { performer: "CAROLE WILSON", character: "Sonyetka" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "JOSEP PONS" },
      { role: "Dirección de escena", name: "ÀLEX OLLÉ" },
      { role: "Escenografía", name: "ALFONS FLORES" },
      { role: "Vestuario", name: "LLUC CASTELLS" },
      { role: "Iluminación", name: "URS SCHÖNEBAUM" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" },
      { role: "Dirección del Coro", name: "PABLO ASSANTE" },
      { role: "Producción", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "El millor moment de Lady Macbeth de Mtsensk", subtitle: "Lady Macbeth de Mtsensk (24/25)", type: "Video", locked: true, duration: "5:23" },
      { id: "ch2", title: "The artistic team", subtitle: "Lady Macbeth de Mtsensk (24/25)", type: "Video", locked: true, duration: "12:45" },
      { id: "ch3", title: "Water in scenography", subtitle: "Lady Macbeth de Mtsensk (24/25)", type: "Video", locked: true, duration: "8:30" },
      { id: "ch4", title: "A chat about Lady Macbeth de Mtsensk", subtitle: "Lady Macbeth de Mtsensk (24/25)", type: "Video", locked: true, duration: "15:20" },
      { id: "ch5", title: "A Frozen Hell", subtitle: "Lady Macbeth de Mtsensk (24/25)", type: "Video", locked: true, duration: "10:15" },
      { id: "ch6", title: "An insight to the history", subtitle: "Lady Macbeth de Mtsensk (24/25)", type: "Video", locked: true, duration: "18:00" },
      { id: "ch7", title: "La previa", subtitle: "Lady Macbeth de Mtsensk", type: "Podcast", locked: true, duration: "45:00" }
    ],
    preparationContent: "Prepara't per a una experiència operística única. Lady Macbeth de Mtsensk és una de les òperes més potents del segle XX.",
    trailerUrl: "https://www.youtube.com/watch?v=example",
    sponsor: "Telefónica"
  },
  {
    id: "tristan-und-isolde",
    title: "Tristan und Isolde",
    composer: "Richard Wagner",
    theater: "Gran Teatre del Liceu",
    season: "25-26",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=1920&q=80",
    status: "coming_soon",
    isFeatured: true,
    premiereDate: "2026-02-15",
    synopsis: "La historia de un amor imposible entre Tristan, caballero de Cornualles, e Isolda, princesa irlandesa prometida al rey Marke. Un filtro de amor desata una pasión que solo puede consumarse en la muerte.",
    synopsisExtended: "Wagner creó una obra maestra que revolucionó la armonía occidental, con su famoso 'acorde de Tristán' que abre las puertas al atonalismo. La ópera explora los límites del amor, el deseo y la redención a través de la muerte.",
    tags: ["ÒPERA", "TRISTAN UND ISOLDE", "WAGNER", "TEMPORADA 25/26"],
    productInfo: {
      theater_name: "Gran Teatre del Liceu",
      recording_year: "2025",
      duration: "4h 30min",
      subtitles_version: "Español, English, Français, Deutsch, Català"
    },
    cast: [
      { performer: "CLAY HILLEY", character: "Tristan" },
      { performer: "LISE DAVIDSEN", character: "Isolde" },
      { performer: "EKATERINA GUBANOVA", character: "Brangäne" },
      { performer: "FRANZ-JOSEF SELIG", character: "König Marke" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "JOSEP PONS" },
      { role: "Dirección de escena", name: "ÀLEX OLLÉ" },
      { role: "Escenografía", name: "ALFONS FLORES" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "The music", subtitle: "Tristan und Isolde (25/26)", type: "Video", locked: true },
      { id: "ch2", title: "The history", subtitle: "Tristan und Isolde (25/26)", type: "Video", locked: true },
      { id: "ch3", title: "The artists", subtitle: "Tristan und Isolde (25/26)", type: "Video", locked: true },
      { id: "ch4", title: "The production", subtitle: "Tristan und Isolde (25/26)", type: "Video", locked: true },
      { id: "ch5", title: "Isolde it's me", subtitle: "Tristan und Isolde (25/26)", type: "Video", locked: true },
      { id: "ch6", title: "La previa", subtitle: "Tristan und Isolde", type: "Podcast", locked: true }
    ],
    sponsor: "Telefónica"
  },
  {
    id: "la-traviata",
    title: "La traviata",
    composer: "Giuseppe Verdi",
    season: "24-25",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1598387993441-a364f854c3e1?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1598387993441-a364f854c3e1?w=1920&q=80",
    status: "available",
    isFeatured: true,
    premiereDate: "2024-11-20",
    synopsis: "Violetta Valéry, una cortesana parisina, renuncia a su vida de lujo por amor a Alfredo Germont. Pero la presión social y familiar la obligarán a tomar una decisión desgarradora.",
    tags: ["ÒPERA", "LA TRAVIATA", "VERDI", "TEMPORADA 24/25"],
    cast: [
      { performer: "NADINE SIERRA", character: "Violetta Valéry" },
      { performer: "JAVIER CAMARENA", character: "Alfredo Germont" },
      { performer: "LUDOVIC TÉZIER", character: "Giorgio Germont" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "RICCARDO FRIZZA" },
      { role: "Dirección de escena", name: "DAVID McVICAR" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "Libiamo ne' lieti calici", subtitle: "La traviata (24/25)", type: "Video", locked: true },
      { id: "ch2", title: "An insight to the history", subtitle: "La traviata (24/25)", type: "Video", locked: true },
      { id: "ch3", title: "I am Marie. I am Marguerite. I am Violetta.", subtitle: "La traviata (24/25)", type: "Video", locked: true },
      { id: "ch4", title: "La previa", subtitle: "La traviata", type: "Podcast", locked: true }
    ]
  },
  {
    id: "madama-butterfly",
    title: "Madama Butterfly",
    composer: "Giacomo Puccini",
    season: "24-25",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1518834107812-67b0b7c58434?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1518834107812-67b0b7c58434?w=1920&q=80",
    status: "available",
    isFeatured: false,
    premiereDate: "2024-12-10",
    synopsis: "Cio-Cio San, una joven geisha japonesa, se casa con el oficial naval americano Pinkerton. Pero él la abandona, dejándola esperando su regreso durante tres años con su hijo.",
    tags: ["ÒPERA", "MADAMA BUTTERFLY", "PUCCINI", "TEMPORADA 24/25"],
    cast: [
      { performer: "AILYN PÉREZ", character: "Cio-Cio San" },
      { performer: "MATTHEW POLENZANI", character: "Pinkerton" },
      { performer: "ANNALISA STROPPA", character: "Suzuki" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "JOSEP PONS" },
      { role: "Dirección de escena", name: "MOSHE LEISER & PATRICE CAURIER" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "Un bel dì, vedremo", subtitle: "Madama Butterfly (24/25)", type: "Video", locked: true },
      { id: "ch2", title: "Bocca chiusa", subtitle: "Madama Butterfly (24/25)", type: "Video", locked: true },
      { id: "ch3", title: "The stranger and the Geishas", subtitle: "Madama Butterfly (24/25)", type: "Video", locked: true }
    ]
  },
  {
    id: "la-guineueta-astuta",
    title: "La guineueta astuta",
    composer: "Leoš Janáček",
    season: "25-26",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=1920&q=80",
    status: "available",
    isFeatured: true,
    premiereDate: "2025-10-01",
    synopsis: "Una fábula musical sobre una zorrita que escapa de la domesticación humana para vivir libre en el bosque. Una reflexión sobre la naturaleza, la libertad y el ciclo de la vida.",
    tags: ["ÒPERA", "LA GUINEUETA ASTUTA", "JANÁČEK", "TEMPORADA 25/26"],
    cast: [
      { performer: "PETER MATTEI", character: "El Guardabosques" },
      { performer: "ELENA TSALLAGOVA", character: "La Guineueta" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "JOSEP PONS" },
      { role: "Dirección de escena", name: "STEFAN HERHEIM" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "The production", subtitle: "La guineueta astuta (25/26)", type: "Video", locked: true },
      { id: "ch2", title: "La prèvia", subtitle: "La guineueta astuta", type: "Podcast", locked: true }
    ]
  },
  {
    id: "elisir-amore",
    title: "L'elisir d'amore",
    composer: "Gaetano Donizetti",
    season: "25-26",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1920&q=80",
    status: "coming_soon",
    isFeatured: true,
    premiereDate: "2025-12-14",
    synopsis: "Nemorino, un campesino enamorado de la bella Adina, compra un 'elixir de amor' al charlatán Dulcamara. Una comedia llena de enredos, arias memorables y un final feliz.",
    tags: ["ÒPERA", "L'ELISIR D'AMORE", "DONIZETTI", "TEMPORADA 25/26"],
    cast: [
      { performer: "PRETTY YENDE", character: "Adina" },
      { performer: "JAVIER CAMARENA", character: "Nemorino" },
      { performer: "AMBROGIO MAESTRI", character: "Dulcamara" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "RICCARDO FRIZZA" },
      { role: "Dirección de escena", name: "MARIO GAS" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "The music", subtitle: "L'elisir d'amore (25/26)", type: "Video", locked: true },
      { id: "ch2", title: "The production", subtitle: "L'elisir d'amore (25/26)", type: "Video", locked: true },
      { id: "ch3", title: "El gran Dulcamara", subtitle: "L'elisir d'amore (25/26)", type: "Video", locked: true }
    ]
  },
  {
    id: "rusalka",
    title: "Rusalka",
    composer: "Antonín Dvořák",
    season: "24-25",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1920&q=80",
    status: "available",
    isFeatured: false,
    premiereDate: "2025-06-15",
    synopsis: "Rusalka, una ninfa acuática, se enamora de un príncipe humano y pide a la bruja Ježibaba que la convierta en humana. Pero el precio será perder su voz y arriesgar su alma.",
    tags: ["ÒPERA", "RUSALKA", "DVOŘÁK", "TEMPORADA 24/25"],
    cast: [
      { performer: "ASMIK GRIGORIAN", character: "Rusalka" },
      { performer: "PIOTR BECZAŁA", character: "El Príncipe" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "JOSEP PONS" },
      { role: "Dirección de escena", name: "STEFAN HERHEIM" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "Mĕsíčku na nebi hlubokém", subtitle: "Rusalka (24/25)", type: "Video", locked: true },
      { id: "ch2", title: "An insight to the history", subtitle: "Rusalka (24/25)", type: "Video", locked: true },
      { id: "ch3", title: "The production", subtitle: "Rusalka (24/25)", type: "Video", locked: true }
    ]
  },
  {
    id: "lohengrin",
    title: "Lohengrin",
    composer: "Richard Wagner",
    season: "24-25",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=1920&q=80",
    status: "available",
    isFeatured: false,
    premiereDate: "2025-03-20",
    synopsis: "Un misterioso caballero llega en un bote tirado por un cisne para defender a Elsa de Brabante, acusada injustamente de asesinar a su hermano. Pero ella no debe preguntar su nombre.",
    tags: ["ÒPERA", "LOHENGRIN", "WAGNER", "TEMPORADA 24/25"],
    cast: [
      { performer: "KLAUS FLORIAN VOGT", character: "Lohengrin" },
      { performer: "MIINA-LIISA VÄRELÄ", character: "Elsa" },
      { performer: "ELISABETH TEIGE", character: "Ortrud" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "JOSEP PONS" },
      { role: "Dirección de escena", name: "CALIXTO BIEITO" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "In fernem land", subtitle: "Lohengrin (24/25)", type: "Video", locked: true },
      { id: "ch2", title: "Un cigne i prou", subtitle: "Lohengrin (24/25)", type: "Video", locked: true }
    ]
  },
  {
    id: "la-sonnambula",
    title: "La sonnambula",
    composer: "Vincenzo Bellini",
    season: "24-25",
    category: "ÒPERA",
    image: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=600&q=80",
    heroImage: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=1920&q=80",
    status: "available",
    isFeatured: false,
    premiereDate: "2025-05-10",
    synopsis: "Amina, una joven campesina, es acusada de infidelidad cuando la encuentran dormida en la habitación del conde. Su sonambulismo será la clave para demostrar su inocencia.",
    tags: ["ÒPERA", "LA SONNAMBULA", "BELLINI", "TEMPORADA 24/25"],
    cast: [
      { performer: "NADINE SIERRA", character: "Amina" },
      { performer: "XABIER ANDUAGA", character: "Elvino" }
    ],
    artisticCredits: [
      { role: "Dirección musical", name: "MAURIZIO BENINI" },
      { role: "Dirección de escena", name: "BÁRBARA LLUCH" },
      { role: "Coro y Orquesta", name: "BRAVO CINEMASTREAMING" }
    ],
    chapters: [
      { id: "ch1", title: "Ah, non giunge", subtitle: "La sonnambula (24/25)", type: "Video", locked: false },
      { id: "ch2", title: "I en el somni, la llibertat", subtitle: "La sonnambula (24/25)", type: "Video", locked: true }
    ]
  }
];

// Helper functions
export const getContentById = (id) => contentDatabase.find(c => c.id === id);

export const getContentBySeason = (season) => contentDatabase.filter(c => c.season === season);

export const getFeaturedContent = () => contentDatabase.filter(c => c.isFeatured);

// Season arrays for carousels
export const season2526 = contentDatabase.filter(c => c.season === "25-26").map(c => ({
  id: c.id,
  title: c.title,
  composer: c.composer,
  status: c.status === "coming_soon" ? `Digital premiere ${c.premiereDate}` : "Edición Especial Disponible",
  artists: c.cast.slice(0, 2).map(m => m.performer).join(" and "),
  image: c.image,
  cta: "CONTRATAR"
}));

export const season2425 = contentDatabase.filter(c => c.season === "24-25" && c.id !== "rusalka").map(c => ({
  id: c.id,
  title: c.title,
  composer: c.composer,
  status: "Edición Especial disponible",
  artists: c.cast.slice(0, 2).map(m => m.performer).join(" & "),
  image: c.image,
  cta: "CONTRATAR"
}));

export const concerts = [
  {
    id: "concert-1",
    title: "'Del dolor a l'esperança'",
    description: "directed by Josep Pons",
    artists: "Nadine Sierra, Elīna Garanča, the ESCOLANIA DE MONTSERRAT choir and the simfònica orchestra and choir from EL GRAN TEATRE Del LICEU",
    image: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=600&q=80",
    cta: "CONTRATAR"
  },
  {
    id: "concert-2",
    title: "Mar i cel",
    description: "Selection of excerpts from \"Mar i cel\" in a symphonic version, by Maestro Albert Guinovart",
    artists: "",
    image: "https://images.unsplash.com/photo-1507676184212-d03ab07a01bf?w=600&q=80",
    cta: "CONTRATAR"
  }
];

export const podcasts = contentDatabase.flatMap(c => 
  c.chapters.filter(ch => ch.type === "Podcast").map(ch => ({
    id: `${c.id}-${ch.id}`,
    title: c.title,
    subtitle: ch.subtitle,
    locked: ch.locked
  }))
);

export const languages = [
  { code: "EN", label: "English" },
  { code: "ES", label: "Español" }
];

// Booking status options
export const bookingStatuses = [
  { value: "pending", label: "Pendiente", color: "yellow" },
  { value: "approved", label: "Aprobado", color: "green" },
  { value: "rejected", label: "Rechazado", color: "red" },
  { value: "confirmed", label: "Confirmado", color: "blue" },
  { value: "completed", label: "Completado", color: "gray" }
];

// Cinema status options
export const cinemaStatuses = [
  { value: "pending", label: "Pendiente", color: "yellow" },
  { value: "approved", label: "Aprobado", color: "green" },
  { value: "rejected", label: "Rechazado", color: "red" }
];

// Technical specs options
export const projectionSystems = ["DCP", "Digital 4K", "Digital 2K", "35mm"];
export const soundSystems = ["Dolby Atmos", "Dolby 7.1", "Dolby 5.1", "Stereo"];
